import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import mascota from '../images/mascota.png';
import mascotaLogin from '../images/mascotaLogin.png';
import { startMesh } from './WelcomeTutorial';

// Tutorial de las cuentas con sesión (diseño en .scratch/tutorial/spec.md; servidor en apps/tutorial.js).
// Popups como los de la Bienvenida, con el Over verde (amable) y el rojo (pícaro) por turnos. Lo que hay
// que pulsar queda resaltado y el resto de la página se oscurece y no se puede pulsar. Va dentro de
// <CookieBanner>, como la Bienvenida.

const LATER_KEY = 'forallia_tutorial_later'; // "Más tarde": hasta que cierre la pestaña
const USUARIO = '#menu-main .userExtender';
const SIN_TUTORIAL = /^\/(privacy|redes|codigos|dataDeletion|adminLogin|LoginOnProgress|LoginYoutubeOnProgress)/i;
const TIENDA = '/myAccount/shop';
const OVERBOX = '/myAccount/overbox';
const INVENTARIO = '/myAccount/rewards';
const MISIONES = '/myAccount/missions';
const PERFIL = '/myAccount';
const COMBATES = 3; // los que hace en el paso de la arena (apps/tutorial.js)
const AVISO_DIRECTO = 'Narux está en directo y los corruptos están viéndole: ahora no se lucha. Ve a verle, que seguimos cuando acabe.';

// Lo comparten las páginas con pasos (Overbox, Tienda, arena): useTutorial() devuelve
// { paso, caja, premios, leLlega, avisar } mientras el tutorial está en marcha, o null.
let compartido = null;
const oyentes = new Set();
function publicar(valor) {
  compartido = valor;
  oyentes.forEach(f => f());
}
export function useTutorial() {
  const [, refrescar] = useState(0);
  useEffect(() => {
    const f = () => refrescar(n => n + 1);
    oyentes.add(f);
    return () => oyentes.delete(f);
  }, []);
  return compartido;
}

const V = mascota;
const R = mascotaLogin;
const tarjeta = (t) => '[data-reward="' + t.premios.pase.id + '"]';
const sinPase = (t) => !t.premios.pase;
const sinRecompensa = (t) => !t.premios.recompensa;
const combatesHechos = (t) => t.tutorial.combates || 0;

// Cada paso: over, texto(t, via). ruta: la página donde ocurre (si está en otra, se le guía por el menú
// de Usuario). objetivo(t): selectores de lo que se resalta, vale el primero que exista; verSolo: se ve
// pero no se pulsa. atajo: si existe, se resalta antes de guiarle por el menú. Avanza con boton, al
// llegar a la ruta (si no tiene nada más), con un aviso de la página cuando se pulsa o pasa algo
// (espera, caja, arena) o escribiendo él solo el pase en el buscador (escribe). salta(t): los que no
// tocan. retoma: el paso desde el que se sigue al volver (otra visita, recarga), porque lo que dejó
// abierto en la página ya no está.
const PASOS = [
  { id: 'hola', over: V, boton: () => 'Siguiente', texto: () => '¡Ya eres de los nuestros, corrupto! Antes de soltarte por Forallia te enseño cómo funciona todo, y hay premios por el camino.' },
  { id: 'usuario', over: R, objetivo: () => [USUARIO], espera: 'menu', texto: () => 'Tranqui, que no muerdo… mucho. Pulsa en tu foto, ahí abajo: ahí guardas todos tus trastos.' },
  { id: 'tienda', over: V, ruta: TIENDA, texto: () => 'Este es tu menú. Entra en la Tienda, que es donde se compran las recompensas.' },
  {
    id: 'buscador', over: R, ruta: TIENDA, objetivo: () => ['.userSearch'], verSolo: true, escribe: true, salta: sinPase,
    texto: () => 'Aquí se busca lo que quieras. Ya te lo escribo yo, que se te ve con prisa.'
  },
  { id: 'tarjeta', over: V, ruta: TIENDA, objetivo: t => [tarjeta(t)], espera: 'tarjeta', salta: sinPase, retoma: 'buscador', texto: t => '¡Mira, el ' + t.premios.pase.name + '! Pulsa en él para verlo de cerca.' },
  { id: 'comprar', over: R, ruta: TIENDA, objetivo: t => ['.tutorialComprar', tarjeta(t)], espera: 'pase', salta: sinPase, retoma: 'buscador', texto: () => 'Venga, cómpratelo. Dale a Comprar, valiente.' },
  {
    id: 'comodin', over: V, boton: () => 'Siguiente', objetivo: t => (t.leLlega ? [] : ['.PopUp']), verSolo: true, salta: sinPase,
    texto: t => (t.leLlega
      ? '¡Anda, si te llega! Se paga con birux comodín, la moneda de las recompensas de valor real. Guárdatelo para cuando tú quieras, que ahora seguimos.'
      : 'Vaya… no te llega. Se paga con birux comodín, la moneda de las recompensas de valor real como esta. La mejor forma de conseguirlos es abrir Overbox.')
  },
  {
    id: 'conseguir', over: R, ruta: OVERBOX, atajo: '.PopUp .PopUpShopButton.heroe',
    texto: (t, via) => (via === 'atajo' ? '¿Sin birux comodín? Pues a por ellos. Dale a Conseguir más.' : 'Nunca sobran, así que a por más. Abre tu menú y entra en Overbox.')
  },
  { id: 'caja1', over: V, ruta: OVERBOX, objetivo: () => ['.tutorialAbrir'], caja: 1, texto: () => 'Estas son las Overbox. Te regalo una: ¡ábrela!' },
  {
    id: 'ahorra', over: R, boton: () => 'Siguiente',
    texto: t => '¿' + t.premios.comodin + ' birux comodín? Je. ' + (t.premios.pase ? 'Para el ' + t.premios.pase.name + ' te toca ahorrar' : 'Te toca ahorrar') + '… y vas a necesitar muchas más Overbox.'
  },
  { id: 'caja2', over: V, ruta: OVERBOX, objetivo: () => ['.tutorialAbrir'], caja: 2, texto: () => 'No pongas esa cara, que te regalo otra. ¡Ábrela!' },
  { id: 'gastar', over: R, boton: () => 'Siguiente', texto: t => t.premios.bronce + ' birux de bronce. Eso quema en el bolsillo: vamos a gastarlos.' },
  { id: 'tienda2', over: V, ruta: TIENDA, texto: () => 'Vuelve a la Tienda: abre tu menú y entra.' },
  { id: 'filtro', over: R, ruta: TIENDA, objetivo: () => ['.currencyFilterBtn'], espera: 'filtro', salta: t => !t.hayBronce, texto: () => 'Pulsa la moneda de bronce y verás solo lo que se paga con birux de bronce.' },
  {
    // La Tienda solo enseña las de bronce que puede pagar con lo del premio, y sin "Comprar y usar".
    id: 'compra', over: V, ruta: TIENDA, objetivo: t => (t.hayBronce ? ['.PopUp', '.infoBox'] : []), espera: 'compra', boton: t => (t.hayBronce ? null : 'Siguiente'),
    texto: t => (t.hayBronce
      ? 'Elige la que quieras de hasta ' + t.premios.bronce + ' birux de bronce y dale a Comprar. Esta va en serio: será tuya.'
      : 'Vaya, ahora mismo no hay ninguna por ' + t.premios.bronce + ' o menos. Guárdate los birux para más adelante.')
  },
  { id: 'hecho', over: R, boton: () => 'Siguiente', texto: t => (t.compro ? '¡Hecho! Ya la tienes en el Inventario. ' : '') + 'Y ahora… sorpresa.' },
  { id: 'overbox3', over: V, ruta: OVERBOX, salta: sinRecompensa, texto: () => 'Te he dejado otra Overbox. Vuelve a Overbox.' },
  { id: 'caja3', over: R, ruta: OVERBOX, objetivo: () => ['.tutorialAbrir'], caja: 3, salta: sinRecompensa, texto: () => 'Ábrela, a ver qué cae…' },
  { id: 'inventario', over: V, ruta: INVENTARIO, salta: sinRecompensa, texto: t => '¡Te ha tocado un ' + t.premios.recompensa.name + '! Lo tienes en tu Inventario: vamos a verlo.' },
  {
    id: 'usar', over: R, ruta: INVENTARIO, objetivo: () => ['.infoBox'], verSolo: true, boton: () => 'Siguiente', salta: sinRecompensa,
    texto: () => 'Aquí guardas tus recompensas. Con Usar la canjeas y Narux se entera; las de directo, solo mientras está en directo. Pero hoy no, que te conozco.'
  },
  { id: 'misiones', over: V, ruta: MISIONES, texto: () => 'Para conseguir más Overbox, cumple misiones. Entra en Misiones.' },
  {
    id: 'directos', over: R, ruta: MISIONES, boton: () => 'Siguiente',
    texto: () => 'Las de ver el directo y escribir en el chat solo salen cuando hay directo o hay uno programado. O sea: nada de saltarte los directos, ¿eh?'
  },
  { id: 'perfil', over: V, ruta: PERFIL, texto: () => 'La otra forma de ganar Overbox es derrotar a otros corruptos. Ve a Mi perfil.' },
  { id: 'luchar', over: R, ruta: PERFIL, objetivo: () => ['.arenaLuchar'], espera: 'luchar', arena: true, texto: () => 'Ahí tienes Luchar. Te he dejado 3 combates para que no tengas excusa. ¡Dale!' },
  {
    // Avanza cuando el servidor ha contado los 3 combates (aviso 'combate' de la arena).
    id: 'combates', over: t => [V, R, V][Math.min(combatesHechos(t), 2)], ruta: PERFIL, objetivo: () => ['.arenaPopUp', '.arenaLuchar'], arena: true,
    texto: t => ['Elige contrincante. Si ganas, te llevas XP o una Overbox. ¡A por él!', '¿Ya está? Otra vez, que te has quedado con ganas.', '¡El último! Tú puedes.'][Math.min(combatesHechos(t), 2)]
  },
  {
    id: 'sinCombates', over: R, ruta: OVERBOX, atajo: '.arenaPopUp',
    texto: t => (t.quedan ? 'Ya llevas tus 3 combates.' : 'Te has quedado sin combates. Pero tranqui:') + ' vuelve a Overbox, que te espera una más.'
  },
  { id: 'caja4', over: V, ruta: OVERBOX, objetivo: () => ['.tutorialAbrir'], caja: 4, texto: () => 'La última que te regalo. ¡Ábrela!' },
  { id: 'masCombates', over: R, boton: () => 'Siguiente', texto: t => '¡' + t.premios.combates + ' combates! En las Overbox también salen combates, así que ya sabes dónde buscar más.' },
  {
    // Solo se le enseña dónde están: no se le lleva a Ajustes ni se activa nada.
    id: 'avisos', over: V, objetivo: () => [USUARIO], verSolo: true, boton: () => 'Siguiente',
    texto: () => 'Una cosa más: si quieres que te avisemos de los códigos nuevos, de los directos o de cuando recuperas combates, lo tienes en tu menú, en Ajustes > Notificaciones. Solo si te apetece, ¿eh?'
  },
  { id: 'fin', over: R, boton: () => 'Terminar', texto: () => 'Ya sabes todo lo que hay que saber, corrupto… o casi. ¡Mucha suerte, que la vas a necesitar!' }
];
// Si no se sabe por dónde iba (paso borrado o sin guardar), por las Overbox que ya abrió.
const DESDE_CAJAS = ['hola', 'ahorra', 'gastar', 'inventario', 'masCombates'];

const indice = (id) => PASOS.findIndex(p => p.id === id);
const navegacion = (p) => p.ruta && !p.objetivo && !p.boton && !p.espera && !p.caja && !p.arena;
const enRuta = (pathname, ruta) => pathname.replace(/\/+$/, '').toLowerCase() === ruta.toLowerCase();
const saltar = (p, t) => !!(p.salta && p.salta(t))
  || (!!p.caja && (t.tutorial.cajas || 0) >= p.caja)
  || (!!p.arena && combatesHechos(t) >= COMBATES);

function leer(key) {
  try {
    return window.sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

const enviar = (body) => fetch('/api/tutorial', {
  method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
}).then(r => r.json()).catch(() => ({}));

// clip-path del velo: toda la pantalla menos el rectángulo resaltado (con 6px de margen).
const hueco = (r) => {
  const [x1, y1, x2, y2] = [r.left - 6, r.top - 6, r.left + r.width + 6, r.top + r.height + 6];
  return `polygon(evenodd, 0 0, 100% 0, 100% 100%, 0 100%, 0 0, ${x1}px ${y1}px, ${x2}px ${y1}px, ${x2}px ${y2}px, ${x1}px ${y2}px, ${x1}px ${y1}px)`;
};

const visibleEl = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return null;
  const r = el.getBoundingClientRect();
  return r.width || r.height ? el : null;
};

/** Lo que hay que resaltar ahora. via: 'atajo' | 'menu' | 'objetivo' | 'nada' (oscurece todo) |
 *  'falta' (lo que tocaba aún no está en la página: no se bloquea nada para que no se quede atascado). */
function buscar(p, t, pathname) {
  if (p.atajo && visibleEl(p.atajo)) return { el: visibleEl(p.atajo), via: 'atajo' };
  if (p.ruta && !enRuta(pathname, p.ruta)) {
    const el = document.querySelector('#userExtendMenu.show')
      ? visibleEl('#userExtendMenu a[href="' + p.ruta + '"]')
      : visibleEl(USUARIO);
    return el ? { el, via: 'menu' } : { el: null, via: 'falta' };
  }
  const lista = p.objetivo ? p.objetivo(t) : [];
  for (const s of lista) {
    const el = visibleEl(s);
    if (el) return { el, via: 'objetivo' };
  }
  return { el: null, via: lista.length ? 'falta' : 'nada' };
}

function Tutorial({ isAuthenticated }) {
  const { pathname, state } = useLocation();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null); // /api/tutorial
  const [paso, setPaso] = useState(null);
  const [later, setLater] = useState(() => leer(LATER_KEY));
  const [pausa, setPausa] = useState(false); // mientras se ve el premio de una Overbox del tutorial
  const [directoVisto, setDirectoVisto] = useState(false);
  const [compro, setCompro] = useState(null);
  const [quedan, setQuedan] = useState(0);
  const [foco, setFoco] = useState({ rect: null, via: 'nada', combate: false });
  const focoRef = useRef({ el: null, via: 'nada' });
  const cajaRef = useRef(null);
  const mallaRef = useRef(null);
  const pasoRef = useRef(null);
  pasoRef.current = paso;

  const cargar = useCallback(async () => {
    try {
      const r = await fetch('/api/tutorial', { credentials: 'include' }).then(res => res.json());
      setInfo(r);
      return r;
    } catch {
      return null;
    }
  }, []);
  useEffect(() => {
    if (isAuthenticated) cargar();
    else setInfo(null);
  }, [isAuthenticated, cargar]);

  // "Consigue más premios" de /codigos lo vuelve a sacar aunque le hubiera dado a "Más tarde".
  useEffect(() => {
    if (state && state.premios) setLater(false);
  }, [state]);

  const activo = !!(info && info.activo);
  const t = activo ? { ...info, compro: compro ?? info.hayBronce, quedan } : null;

  /** Va al primer paso desde i que toque y lo guarda. */
  const irA = useCallback((i, datos) => {
    const tt = { ...datos, quedan: 0 };
    while (i < PASOS.length - 1 && saltar(PASOS[i], tt)) {
      // La 3.ª Overbox sin recompensa (borrada o desactivada): se salta, pero cuenta como abierta.
      if (PASOS[i].caja === 3 && (tt.tutorial.cajas || 0) === 2) enviar({ accion: 'abrir' });
      i++;
    }
    setPaso(PASOS[i].id);
    enviar({ accion: 'paso', paso: PASOS[i].id });
  }, []);
  const avanzar = useCallback((datos) => irA(indice(pasoRef.current) + 1, datos), [irA]);

  // Al empezar: donde lo dejó (en este u otro dispositivo).
  useEffect(() => {
    if (!activo || paso) return;
    const guardado = PASOS[indice(info.tutorial.paso)];
    irA(indice(guardado ? guardado.retoma || guardado.id : DESDE_CAJAS[info.tutorial.cajas || 0] || 'hola'), info);
  }, [activo, paso, info, irA]);

  const p = paso ? PASOS[indice(paso)] : null;

  // Las páginas avisan: 'menu' (menú de Usuario), 'cajaAbierta' / 'caja' (Overbox), 'tarjeta' / 'pase' /
  // 'filtro' / 'compra' (Tienda), 'luchar' (Mi perfil), 'combate' (arena).
  const avisar = useCallback(async (evento) => {
    if (evento === 'cajaAbierta') return setPausa(true);
    if (evento === 'compra') setCompro(true);
    const datos = await cargar();
    if (evento === 'caja') setPausa(false);
    if (!datos || !datos.activo) return;
    const actual = PASOS[indice(pasoRef.current)];
    if (!actual) return;
    if (actual.espera === evento || (evento === 'caja' && actual.caja) || (evento === 'combate' && actual.arena && combatesHechos(datos) >= COMBATES)) {
      avanzar(datos);
    }
  }, [cargar, avanzar]);

  const fuera = later || SIN_TUTORIAL.test(pathname);
  useEffect(() => {
    publicar(activo && p && !fuera
      ? { paso: p.id, caja: p.caja || null, premios: info.premios, leLlega: info.leLlega, avisar }
      : null);
  }, [activo, p, fuera, info, avisar]);
  useEffect(() => () => publicar(null), []);

  // Pasos de ir a otra página: avanzan al llegar.
  useEffect(() => {
    if (activo && p && navegacion(p) && enRuta(pathname, p.ruta)) avanzar(info);
  }, [activo, p, pathname, info, avanzar]);

  // Tras los 3 combates: si aún le quedan (extras), el texto cambia.
  useEffect(() => {
    if (paso !== 'sinCombates') return;
    fetch('/api/arena/estado', { credentials: 'include' }).then(r => r.json()).then(e => setQuedan(e.disponibles || 0)).catch(() => { });
  }, [paso]);

  // El paso de la arena: le pone los combates a 3 (una vez; lo controla el servidor) y mira si hay directo.
  useEffect(() => {
    if (paso === 'luchar') enviar({ accion: 'recarga' }).then(cargar);
  }, [paso, cargar]);

  // En directo no se lucha: espera y mira de vez en cuando si ha acabado.
  const directo = !!(activo && p && p.arena && info.enDirecto);
  useEffect(() => {
    if (!directo) {
      setDirectoVisto(false);
      return undefined;
    }
    const intervalo = setInterval(cargar, 30000);
    return () => clearInterval(intervalo);
  }, [directo, cargar]);

  const visible = activo && p && !fuera && !pausa && !(directo && directoVisto);

  // Sigue lo que hay que resaltar (se mueve, aparece o desaparece con la página).
  useEffect(() => {
    if (!visible) return undefined;
    let raf;
    let ultimo = '';
    let ultimoEl = null;
    const mirar = () => {
      const { el, via } = directo ? { el: null, via: 'nada' } : buscar(p, t, pathname);
      const rect = el ? el.getBoundingClientRect() : null;
      const combate = !!(p.arena || p.id === 'sinCombates') && !!document.querySelector('.arenaPopUp[aria-label="Combate"]');
      if (el && el !== ultimoEl && (rect.bottom < 0 || rect.top > window.innerHeight)) el.scrollIntoView({ block: 'center' });
      ultimoEl = el;
      focoRef.current = { el, via };
      const clave = via + (rect ? [rect.top, rect.left, rect.width, rect.height].map(Math.round).join() : '') + combate;
      if (clave !== ultimo) {
        ultimo = clave;
        setFoco({ rect: rect && { top: rect.top, left: rect.left, width: rect.width, height: rect.height }, via, combate });
      }
      raf = requestAnimationFrame(mirar);
    };
    mirar();
    return () => cancelAnimationFrame(raf);
    // t cambia en cada render; lo que importa de él viene con info, compro y quedan.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, p, pathname, info, compro, quedan, directo]);

  // Fuera de lo resaltado no se puede pulsar (se captura antes que React, que escucha en document).
  // Solo bloquea: los pasos los avanzan los avisos de las páginas, porque en algún móvil este click
  // no llegaba y el paso se quedaba atascado.
  useEffect(() => {
    if (!visible) return undefined;
    const bloquear = (e) => {
      if (cajaRef.current && cajaRef.current.contains(e.target)) return;
      const { el, via } = focoRef.current;
      if (via === 'falta') return;
      const pulsable = el && !(p.verSolo && via === 'objetivo');
      if (pulsable && el.contains(e.target)) return;
      if (e.cancelable && e.type !== 'touchstart') e.preventDefault();
      e.stopPropagation();
      // Dentro del hueco pero encima hay otra cosa (un aviso de la web que se quedó abierto debajo del
      // velo): el toque es para lo resaltado.
      if (pulsable && e.type === 'click') {
        const r = el.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) el.click();
      }
    };
    const tipos = ['click', 'mousedown', 'pointerdown', 'touchstart'];
    tipos.forEach(tipo => window.addEventListener(tipo, bloquear, { capture: true, passive: tipo === 'touchstart' }));
    return () => tipos.forEach(tipo => window.removeEventListener(tipo, bloquear, { capture: true }));
  }, [visible, p]);

  // El buscador se escribe solo: a los 3 s de enseñar el mensaje en la Tienda, letra a letra (por el
  // ?search= de la URL, que es lo que lee la Tienda), y sigue sin que tenga que tocar nada.
  const escribir = visible && p.escribe && !directo && enRuta(pathname, p.ruta) ? info.premios.pase.name : null;
  useEffect(() => {
    if (!escribir) return undefined;
    let n = 0;
    let timer;
    const letra = () => {
      n++;
      navigate(TIENDA + '?search=' + encodeURIComponent(escribir.slice(0, n)), { replace: true });
      timer = n < escribir.length ? setTimeout(letra, 120) : setTimeout(() => avanzar(info), 600);
    };
    timer = setTimeout(letra, 3000);
    return () => clearTimeout(timer);
    // Solo vuelve a empezar si cambia el texto o deja de verse (Más tarde, otra página)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [escribir]);

  // La malla de la Bienvenida de fondo; sigue entre paso y paso para que no parpadee.
  const conVelo = visible && !foco.combate && foco.via !== 'falta';
  useEffect(() => (conVelo ? startMesh(mallaRef.current) : undefined), [conVelo]);

  if (!visible || foco.combate) return null;

  const masTarde = () => {
    try {
      window.sessionStorage.setItem(LATER_KEY, '1');
    } catch { }
    setLater(true);
  };
  const pulsarBoton = async () => {
    if (p.id === 'fin') {
      await enviar({ accion: 'terminar' });
      cargar();
    } else {
      avanzar(info);
    }
  };

  const { rect, via } = foco;
  const boton = !directo && p.boton ? p.boton(t) : null;
  // La caja va donde no tape lo resaltado: arriba si está en la mitad de abajo, y al revés. Si lo
  // resaltado es muy alto (el popup de la arena), compacta, con el Over pequeño al lado del texto.
  const lado = !rect ? 'centro' : rect.top + rect.height / 2 > window.innerHeight / 2 ? 'arriba' : 'abajo';
  const compacto = !!rect && rect.height > window.innerHeight * 0.4;
  const over = directo ? R : typeof p.over === 'function' ? p.over(t) : p.over;

  return (
    <>
      {conVelo ? (
        // Con algo resaltado, el velo lleva un hueco encima (y entonces no captura clicks: los bloquea el efecto de arriba)
        <div className={'tutorialVelo' + (rect ? ' hueco' : '')} style={rect ? { clipPath: hueco(rect) } : undefined}>
          <canvas ref={mallaRef} className='welcomeMesh' />
        </div>
      ) : null}
      {rect ? <div className='tutorialFoco' style={{ top: rect.top - 6, left: rect.left - 6, width: rect.width + 12, height: rect.height + 12 }} /> : null}
      <div ref={cajaRef} className={'welcomeBox heroes tutorialBox ' + lado + (compacto ? ' compacto' : '')} role='dialog' aria-live='polite'>
        <img className='welcomeMascot' src={over} alt='' />
        <div>
          <p>{directo ? AVISO_DIRECTO : p.texto(t, via)}</p>
          <div className='welcomeActions'>
            {directo ? <button className='avisoSesion-btn' onClick={() => setDirectoVisto(true)}>Entendido</button> : null}
            {boton ? <button className='avisoSesion-btn' onClick={pulsarBoton}>{boton}</button> : null}
            {!directo ? <button className='avisoSesion-btn welcomeLater' onClick={masTarde}>Más tarde</button> : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default Tutorial;
